$(document).on('ready turbolinks:load', () => {
  const nameSelector = 'input#teacher-name';
  $(document).off('keyup', nameSelector).on('keyup', nameSelector, (event) => {
    const name = $(event.currentTarget).val().trim();
    $('input#klass_teacher_attributes_first_name').val(name.split(' ').slice(0, 1).join(' '));
    $('input#klass_teacher_attributes_last_name').val(name.split(' ').slice(1).join(' '));
  });
});
